/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_PrdInputs */

const en_cmp_row_prd = /** @type {(inputs: Cmp_Row_PrdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD generation`)
};

const id_cmp_row_prd = /** @type {(inputs: Cmp_Row_PrdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembuatan PRD`)
};

/**
* | output |
* | --- |
* | "PRD generation" |
*
* @param {Cmp_Row_PrdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_prd = /** @type {((inputs?: Cmp_Row_PrdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_PrdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_prd(inputs)
	return en_cmp_row_prd(inputs)
});